/**
 * Etiquetas de los grupos etarios (`PrescriptionModel.ageGroupType`),
 * compartidas por los reportes de producción (Excel, impresión y filtros).
 */
export const AGE_GROUP_LABELS: Record<string, string> = {
  Neo: 'Neonatal',
  Pediatric: 'Pediátrico',
  Adults: 'Adulto',
};
